import { PublicRegistryComponent } from './public-registry.component';
import { publicRegistryRecordResolver, publicRegistryResolver } from './public-registry-resolver.service';
import { PublicRegistryRecordComponent } from 'pages/public-registry/public-registry-record/public-registry-record.component';
import { PublicRegistryTableComponent } from 'pages/public-registry/public-registry-table/public-registry-table.component';
import { authGuard } from 'directives/auth-guard';

export const PublicRegistryRouting = [
  {
    path: ':registryId',
    component: PublicRegistryComponent,
    children: [
      {
        path: '',
        component: PublicRegistryTableComponent,
        resolve: {
          data: publicRegistryResolver,
        },
      },
      {
        path: ':numberInstanceId',
        component: PublicRegistryRecordComponent,
        resolve: {
          record: publicRegistryRecordResolver,
        },
      },
    ],
  },
];

export const RegistryRouting = [
  {
    path: 'preview',
    loadChildren: () =>
      import('pages/public-registry/preview-registry/preview-registry.module').then((m) => m.PreviewRegistryModule),
    canActivate: [authGuard],
  },
  ...PublicRegistryRouting,
];
